import { render, staticRenderFns } from "./individual.vue?vue&type=template&id=c27bbb16&scoped=true"
import script from "./individual.vue?vue&type=script&lang=js"
export * from "./individual.vue?vue&type=script&lang=js"
import style0 from "./individual.vue?vue&type=style&index=0&id=c27bbb16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27bbb16",
  null
  
)

export default component.exports